var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.34 10.824 4.98-5.001c.47-.47.47-1.23 0-1.697a1.204 1.204 0 0 0-1.7.004l-7.01 7.038a1.19 1.19 0 0 0 0 1.69l7.01 7.08c.46.472 1.22.476 1.69.01.48-.466.48-1.227.01-1.697l-4.97-5.027h14.2c.66 0 1.2-.537 1.2-1.2 0-.662-.54-1.2-1.2-1.2H6.34Z",
    fill: "#000"
  })));
};
export default SvgArrow;